import { render, staticRenderFns } from "./VehicleShopsPage.vue?vue&type=template&id=b0db1968&"
import script from "./VehicleShopsPage.vue?vue&type=script&lang=js&"
export * from "./VehicleShopsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports